import { css, jsx } from '@emotion/core';
import { Col, Tag, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { bp, colors, form as formStyle, space } from '@/styles';

const style = {
  filterTag: css`
    height: 30px;
    min-width: 83px;
    border-radius: 2px;
    border: 1px solid ${colors.accentGrayLight};
    background: #ffffff !important;
    font-size: 1.2rem;
    display: inline-flex;
    align-items: center;
    font-weight: 900;
    .anticon-close {
      color: ${colors.secondaryGray};
      font-size: 1.4rem;
      margin-left: auto;
      margin-right: 4px;
      transform: translateX(4px);
    }
  `,
};

const TagTile = props => {
  const { tag, tagClose } = props;
  const { children, value, input } = tag;
  const childrenStr = children.toString();
  const isLongTag = childrenStr.length > 20;

  const tagNode = (
    <Tag
      style={{ backgroundColor: 'white' }}
      css={style.filterTag}
      key={`${input}--${value}`}
      closable
      onClose={e => tagClose(e, value, input)}
    >
      {isLongTag ? `${childrenStr.slice(0, 20)}...` : childrenStr}
    </Tag>
  );

  return isLongTag ? (
    <Tooltip title={childrenStr} key={`${input}--${value}`}>
      {tagNode}
    </Tooltip>
  ) : (
    tagNode
  );
};

TagTile.propTypes = {};

export default TagTile;
